import React from 'react';
import { UpArrow } from '../icons/Icons';

const PageOne = (props) => {
  return (
    <div className="kids-quiz__page">
      <h1>Let's get started...</h1>

      <div className="kids-quiz__question">
        <label>What's your name?</label>
        <input type="text" onChange={e => props.setKidsName(e.target.value.replace(/(?:^|-)\S/g, a => a.toUpperCase()))} value={props.kidsName}></input>
      </div>

      <a href="#gender" className={`question-divider ${props.kidsName ? 'question-divider--show' : ''}`}>
        <UpArrow />
      </a>

      <div id="gender" className={`kids-quiz__question ${props.kidsName ? 'kids-quiz__question--show--delayed' : 'kids-quiz__question--hidden'}`}>
        <p className="question__title">Are you...</p>
        <div className="answers-row--3">
          {props.renderGenderAnswers}
        </div>
      </div>

      {props.gender !== 'male' ?
        <>
          <a href="#pregnant" className={`question-divider ${props.gender && props.gender !== 'male' ? 'question-divider--show' : ''}`}>
            <UpArrow />
          </a>

          <div id="pregnant" className={`kids-quiz__question ${props.gender && props.gender !== 'male' ? 'kids-quiz__question--show' : 'kids-quiz__question--hidden'}`}>
            <p className="question__title">Are you pregnant, breastfeeding or trying for a baby?</p>
            <div className="radio-answers answers-row--2">
              <input type="radio" name="pregnant" id="pregnantYes" value="yes" onChange={props.logPregnantAnswer} checked={props.pregnantAnswer === 'yes'} />
              <label className="answer-button answer-button__pregnant" htmlFor="pregnantYes">Yes</label>

              <input type="radio" name="pregnant" id="pregnantNo" value="no" onChange={props.logPregnantAnswer} checked={props.pregnantAnswer === 'no'} />
              <label className="answer-button answer-button__pregnant" htmlFor="pregnantNo">No</label>
            </div>
          </div>
        </>
        : ''
      }

      {props.pregnantAnswer === 'yes' ?
        <div className="pregnancy-text">
          <p>All of the Patina blends are safe for women who are trying for a baby.</p>
          <p>
            We don't currently offer a range on site which is specifically formulated for pregnant women or those who have recently given birth and are breastfeeding.
          </p>
          <p>
            If you would like to learn more about the doctor recommended blends from Nourished which are curated for pregnancy, please view our full range at <a href="https://get-nourished.com/collections/pre-blends/products/pre-blend-prenatal">here</a>.
          </p>
        </div>
        : ''
      }


      <a href="#age" className={`question-divider ${props.kidsName && props.gender ? 'question-divider--show' : ''}`}>
        <UpArrow />
      </a>

      <div id="age" className={`kids-quiz__question ${props.kidsName && props.gender ? 'kids-quiz__question--show' : 'kids-quiz__question--hidden'}`}>
        <label className="question__title">How old are you?</label>
        <input onChange={props.onChangeNumber} onBlur={props.checkAge} value={props.age} pattern="\d*"></input>
      </div>

      {props.ageWarningMessage()}

      <div className={`next-page ${props.suitableAge && props.age ? 'next-page--show' : 'next-page--hidden'}`} onClick={() => props.nextPage('1')}>Continue</div>
    </div>
  );
}

export default PageOne;